// ScreenSizePopup.js
import React from 'react';
import { Modal, Button, Row, Col } from 'antd';
import screens from '../../../../assets/images/screens.png';
import { useTranslation } from 'react-i18next';

const ScreenSizePopup = ({ visible, onContinue }) => {
    const { t } = useTranslation()
    return (
        <Modal
            open={visible}
            centered
            closable={false}
            footer={null}
            className="c-customModal"
            zIndex={9999}
        >
            <Row justify='center'>
                <Col>
                    <img src={screens} alt="" />
                </Col>
                <Col span={20} offset={1}>
                    <div className='c-heading md dont-break text-center mb-2'>
                        {t('GRAAS_SCREEN_SIZE_POPUP_MESSAGE_GRAAS')}
                    </div>
                </Col>
                <Col>
                    <Button className='c-button is-filled' onClick={() => onContinue()} >{t('GRAAS_CONTINUE_GRAAS')}</Button>
                </Col>
            </Row>
        </Modal>
    );
};

export default ScreenSizePopup;
